package ru.astrainteractive.kobwebx.core.theme.model

enum class ThemeType {
    DARK, LIGHT
}
